import { useState, useMemo } from 'react'
import { CardGroupWithDropDownFilterProps, RestaurantType } from '~types'
import DropDownGroup from '../DropDownGroup/DropDownGroup'
import { normalizeTaxonomyData } from 'utils/transform/normalizeTaxonomyData'
import { filterDataByTaxonomy } from 'utils/filters/filterDataByTaxonomy'
import styles from './CardGroupWithDropDownFilter.module.scss'
import CardGroup from '../CardGroup/CardGroup'
import { Heading } from '~elements'
import { normalizeDataToCard } from 'utils/transform/normalizeDataToCard'

const CardGroupWithDropDownFilter = ({
  headline,
  dropDownGroup,
  dataOptions,
  cardGroup
}: CardGroupWithDropDownFilterProps) => {
  const [selectedFilters, setSelectedFilters] = useState<{ [key: string]: string }>({})

  const normalizedDropDowns = useMemo(() => {
    return normalizeTaxonomyData(dropDownGroup?.dropDowns || [])
  }, [dropDownGroup?.dropDowns])

  const normalizedRestaurants = useMemo(() => {
    return normalizeDataToCard(dataOptions || []) as RestaurantType[]
  }, [dataOptions])

  const filteredData = useMemo(() => {
    return filterDataByTaxonomy(normalizedRestaurants || [], selectedFilters)
  }, [dataOptions, selectedFilters])

  const handleDropDownChange = (value: string, type: string) => {
    setSelectedFilters(prev => {
      const newFilters = { ...prev }

      if (value === '') {
        delete newFilters[type]
      } else {
        newFilters[type] = value
      }

      return newFilters
    })
  }

  return (
    <div className={styles.cardGroupWithDropDownFilter}>
      {headline && (
        <div className={styles.headline}>
          <Heading {...headline} noMarginBottom noMarginTop>
            {headline.title}
          </Heading>
        </div>
      )}
      {normalizedDropDowns && normalizedDropDowns.length > 0 && (
        <div className={styles.filtersContainer}>
          <p>Restaurants ({filteredData.length})</p>
          <DropDownGroup dropDowns={normalizedDropDowns} onDropDownChange={handleDropDownChange} />
        </div>
      )}
      {filteredData.length > 0 ? (
        <CardGroup {...cardGroup} cards={filteredData} hasFilters />
      ) : (
        <div className={styles.noOptionsContainer}>
          <Heading level={3} justify='center'>No options available</Heading>
        </div>  
      )}
    </div>
  )
}

export default CardGroupWithDropDownFilter
